import { render } from "./EdificioTypeBadge.vue?vue&type=template&id=da646de0"
import script from "./EdificioTypeBadge.vue?vue&type=script&lang=js"
export * from "./EdificioTypeBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__